import axios from "axios";

const apiAuthUser = {
	async autentificaUser(requestData) { 
		//validar al usuario y obtener token de autentificación          
		const response = await axios.post("/api/users/authlogin",requestData);  
		return response.data;        
	},
	async readUsers() {           
		const response = await axios.get("/api/users");  
		return response.data;        
	},
	async readNoPlazas() {           
		const response = await axios.get("/api/users/plazas");  
		return response.data;        
	},
	async createUser(requestData) {
		const response = await axios.post("api/users/register", requestData);
		return response.data;
	},
	async updateUser(nomUser, requestData) {
		const response = await axios.put("api/users/"+nomUser, requestData);
		return response.data;
	},
	async deleteUser(idUser) {
		const response = await axios.delete("api/users/"+idUser);
		return response.data;
	},
	async updatePassword(idUser, requestData) {
		const response = await axios.put("api/users/passwd"+idUser, requestData);
		return response.data;
	}
};

export default apiAuthUser;
